import React from 'react';
import { InputAdornment } from '@mui/material';
import NumericTextField, {
  type NumericTextFieldProps,
} from './NumericTextField';

export type AdornedPercentageInputProps = Omit<
  NumericTextFieldProps,
  'slotProps'
>;

const AdornedPercentageInput: React.FC<AdornedPercentageInputProps> = (
  props,
) => {
  return (
    <NumericTextField
      {...props}
      slotProps={{
        input: {
          endAdornment: <InputAdornment position='start'>%</InputAdornment>,
        },
      }}
    />
  );
};

export default AdornedPercentageInput;
